import React from "react";
import card_config from "../../gpap-lib/StartCard/card_config";
import Grid from "@mui/material/Grid";
import StartCard from "../../gpap-lib/StartCard/StartCard";



export const getCards = () => {
    return card_config.map(function (item) {
        return <Grid key={item.title} item lg={3}><StartCard
            item={item}/></Grid>


    });
};
